export default String.raw`
{% assign homepageSmallSliderSize = config.Banners['homepage-small'].Images | Size -%}
{% if homepageSmallSliderSize > 0 -%}
    <section class="infographicBanner" data-timer="{% if settings.infographicBannerAutoplayToggle == 'yes' -%}{{ settings.infographicBannerAutoplaySpeed }}{% endif -%}">
        <div class="infographicBanner__prev arrow shadowed">
            <svg class="arrow__icon">
                <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
            </svg>
        </div>
        <div class="infographicBanner__next arrow shadowed">
            <svg class="arrow__icon">
                <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
            </svg>
        </div>
        <div class="infographicBanner__swiper swiper">
            {% assign slidesNumber = config.Banners['homepage-small'].Images | Size -%}
            <div class="infographicBanner__wrapper swiper-wrapper" data-len="{{ slidesNumber }}">
                {% for slide in config.Banners['homepage-small'].Images -%}
                    <div class="infographicBanner__slide swiper-slide">
                        {% if slide.Link != empty -%}
                            {% capture slideHref -%}{% include 'partials/common/user-link.html', userLink: slide.Link -%}{% endcapture -%}
                            <a href="{{ slideHref }}" {% if slide.TargetBlank %} target="_blank" {% endif -%} rel="noopener noreferrer">
                        {% endif -%}
                                <div class="infographicBanner__slide-container">
                                    <div class="infographicBanner__slide-container-circle">
                                        <img src="{{ slide.Url }}" 
                                            alt="{{ slide.Alt }}" 
                                            {% unless bodyInfographicBannerNo == 1 -%}loading="{% if forloop.index0 == 0 -%}eager{% else -%}lazy{% endif -%}"{% endunless -%}
                                        >
                                    </div>
                                    <div class="infographicBanner__slide-container-text">
                                        <h3>{{ slide.Heading }}</h3>
                                        <p>{{ slide.Text }}</p>
                                    </div>
                                </div>
                        {% if slide.Link != empty -%}
                            </a>
                        {% endif -%}
                    </div>
                {% endfor -%}
            </div>
            <div aria-label="{{translations.PauseSlide}}" role="button" tabindex="0" class="infographicBanner-pause-button swiper-button-pause">
                <svg class="pause-icon">
                    <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#pause-circle-{{ settings.iconStyle }}'></use>
                </svg>
            </div>
        </div>
    </section>
{% endif -%}
`